import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { Box } from "@mui/system";
import { Resource, useSidebarState } from "react-admin";
import { useTranslation } from "react-i18next";
import { AuthContext } from "@/providers/AuthContextProvider";
import { Tabs } from "@/components/Tabs";
import { HeaderTitle } from "@/components/HeaderTitle";
import { SettingsLanguages } from "@/resources/Settings/SettingsLanguages";
import { SettingsTemplates } from "@/resources/Settings/SettingsTemplates";
import { SettingsVotingChannels } from "@/resources/Settings/SettingsVotingChannel";
import { SettingsElectionsTypes } from "@/resources/Settings/SettingsElectionsTypes";
import { SettingsElectionsTypesCreate } from "@/resources/Settings/SettingsElectionsTypesCreate";
import { IPermissions } from "@/types/keycloak";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { Typography } from "@mui/material";
import { SettingsTrustees } from "@/resources/Settings/SettingsTrustees";
import { SettingsLookAndFeel } from "@/resources/Settings/SettingsLookAndFeel";
import { SettingsIntegrations } from "@/resources/Settings/SettingsIntegrations";
import { SettingsCountries } from "@/resources/Settings/SettingsCountries";
import SettingsLocalization from "@/resources/Settings/SettingsLocalization";
import { SettingsBackupRestore } from "@/resources/Settings/SettingsBackupRestore";
import { SettingsPreviews } from "@/resources/Settings/SettingsPreviews";
export var SettingsScreen = function () {
    var t = useTranslation().t;
    var authContext = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var hasPermissions = authContext.isAuthorized(true, tenantId, IPermissions.TENANT_WRITE);
    var open = useSidebarState()[0];
    var showSettingsMenu = authContext.isAuthorized(true, tenantId, IPermissions.SETTINGS_MENU);
    if (!hasPermissions || !showSettingsMenu) {
        return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("electionTypeScreen.noPermissions") }) }));
    }
    return (_jsxs(Box, { sx: { maxWidth: "calc(100vw - ".concat(open ? "352px" : "96px", ")"), bgcolor: "background.paper" }, className: "settings-box", children: [_jsx(HeaderTitle, { title: String(t("electionTypeScreen.common.settingTitle")), subtitle: String(t("electionTypeScreen.common.settingSubtitle")) }), _jsx(Tabs, { elements: [
                    {
                        label: t("electionTypeScreen.tabs.electionTypes"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_election_type", list: SettingsElectionsTypes, create: SettingsElectionsTypesCreate, edit: SettingsElectionsTypesCreate, show: SettingsElectionsTypesCreate })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.votingChannels"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsVotingChannels })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.templates"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsTemplates })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.languages"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsLanguages })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.localization"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsLocalization })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.integrations"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsIntegrations })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.lookAndFeel"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsLookAndFeel })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.trustees"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_trustee", list: SettingsTrustees })); },
                    },
                    {
                        label: "Countries",
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsCountries })); },
                    },
                    {
                        label: t("electionTypeScreen.tabs.BackupRestore"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_tenant", list: SettingsBackupRestore })); },
                    },
                    {
                        label: t("settings.previewScreen.label"),
                        component: function () { return (_jsx(Resource, { name: "sequent_backend_preview", list: SettingsPreviews })); },
                    },
                ] })] }));
};
